import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, FormArray } from '@angular/forms';

@Component({
  selector: 'app-sync-devices-dialog',
  templateUrl: './sync-devices-dialog.component.html',
  styleUrls: ['./sync-devices-dialog.component.css']
})
export class SyncDevicesDialogComponent implements OnInit {
  devicesData: any[];
  // device = [
  //   {thingName: 'Hydrogen', alternateName: null},
  //   {thingName: 'Helium', alternateName: null},
  // ]

  displayedColumns: string[] = ['select', 'thingName', 'alternateName'];
  dataSource: any;
  // dataSource = new MatTableDataSource(this.device);
  selection = new SelectionModel<any>(true, []);

  controls: FormArray;

  constructor(
      private dialogRef: MatDialogRef<SyncDevicesDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
    this.devicesData = this.data.devices;
    this.dataSource = new MatTableDataSource(this.devicesData);
    const toGroups = this.devicesData.map(el => {
      return new FormGroup({
        thingName: new FormControl(el.thingName),
        alternateName: new FormControl(el.alternateName)
      });
    });
    this.controls = new FormArray(toGroups);
  }

  getControl(index: number, field: string): FormControl {
    return this.controls.at(index).get(field) as FormControl;
  }

  updateField(index: number, field: string) {
    const control = this.getControl(index, field);

    if (control.valid) {
      this.devicesData = this.devicesData.map((e, i) => {
        if (index === i) {
          return {
            ...e,
            [field]: control.value
          }
        }
        return e;
      })
    }

  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  cancel() {
    this.dialogRef.close();
  }

  close() {
    // this.dialogRef.close(this.selection.selected);
    // this.dialogRef.close(this.controls.value);

    const result = this.controls.value.filter( el => {
      return this.selection.selected.some( f => {
        return f.thingName === el.thingName;
      });
    });

    this.dialogRef.close(result);
  }
}

export interface DialogData {
  title: string;
  note: string;
  devices: any
}

